export class Currency {
  /**
   * Formata números para o padrão pt-BR
   * @params {number} value Valor a ser formatado
   * @returns {string} valor formatado
   * */

  static formatCurrency(value, removeSymbol = false, digits) {
    const money = (value || 0).toLocaleString("pt-BR", {
      ...(digits > 0 && {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }),
      ...(removeSymbol && {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      ...(!removeSymbol && {
        style: "currency",
        currency: "BRL",
      })
    });

    return money;
  }
}
